import http from "@/shared/services/http";

export const listLadingErrorCustomer = (params: any) => http.get(`v1/customer/lading-errors`, { params });
export const singleLadingErrorCustomer = (id: any) => http.get(`v1/customer/lading-errors/${id}`);
export const responseLadingErrorCustomer = (data: any) => http.put(`v1/customer/lading-errors/${data.id}`, data);